
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";
import { useAppConfiguration } from "@domain/AppConfiguration";

import DealershipDetails from "./DealershipDetails/DealershipDetails.vue";
import SetHomeDealership from "./SetHomeDealership/SetHomeDealership.vue";

const app = useAppConfiguration();

useBackButton( true, true );

</script>

<template>

    <div class="w-full h-full">

        <SetHomeDealership v-if="app.isGeneric" />
        <DealershipDetails v-else />
        
    </div>   
    
</template>
